import { BASE_API_URL } from "api/api.config"
import { Endpoint } from "api/enpoints.types"

export const useQueryStudentCleverLogin = () => {
  const cleverLoginUrl = `${BASE_API_URL}${Endpoint.STUDENTS_LOGIN_CLEVER}`

  const refetch = () => {
    window.location.href = cleverLoginUrl
  }

  return {
    refetch,
  }
}
